export class Application {
  applicationId
  processorId
  claimAmount
  name

  constructor(application = {}) {
    this.applicationId = application.applicationId ? String(application.applicationId) : ''
    this.processorId = application.processorId ? String(application.processorId) : ''
    this.claimAmount = application.claimAmount ? Number(application.claimAmount) : 0
    this.name = application.name ? String(application.name) : ''
  }
}